import { CopyAll } from '@mui/icons-material';
import { Box, Typography, useSnackbar, useTheme } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

export type CopyIdProps = {
  id: string;
  /** Truncate long ids with ellipsis; use in constrained layouts (e.g. dialog headers). */
  truncate?: boolean;
};

export const CopyId = ({ id, truncate = false }: CopyIdProps) => {
  const { t } = useTranslation('shared');
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Box
      sx={{
        background: theme.color.background,
        padding: '0px 16px',
        height: '32px',
        borderRadius: theme.borderRadius.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        ...(truncate && { maxWidth: '100%', minWidth: 0 }),
        '&:hover': {
          background: theme.color.neutralPressed,
        },
      }}
      onClick={() => {
        navigator.clipboard.writeText(id);
        enqueueSnackbar(t('copiedToClipboard'), { variant: 'success' });
      }}
    >
      <Typography
        variant='labelLarge'
        sx={
          truncate
            ? {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                minWidth: 0,
                flex: 1,
              }
            : undefined
        }
      >
        {id}
      </Typography>
      <CopyAll sx={{ fontSize: '16px', ml: 1, flexShrink: 0 }} />
    </Box>
  );
};
